import {
    fetchFingerprintSignupReport,
    FingerprintSignupReportData,
} from 'features/reports/fingerprintSignupReportSlice'
import { useAppDispatch, useAppSelector } from 'hooks/hooks'
import { useCurrentCountry } from 'hooks/miscHooks'
import { useCallback, useMemo } from 'react'
import ReportList, { ColumnDefinition, ReportData } from './common/ReportList'
import { renderDate, renderProviderId, renderText } from './common/reportRenderers'

const FingerprintSignupReportList = () => {
    const dispatch = useAppDispatch()
    const country = useCurrentCountry()

    const { pages, rows, pagination, filters, isLoading } = useAppSelector(
        (state) => state.fingerprintSignupReport,
    )

    const columns = useMemo(
        (): ColumnDefinition[] => [
            { key: 'fingerprint_signup_event_id', name: 'Event ID' },
            { key: 'service_provider_id', name: 'Provider ID' },
            { key: 'business_name', name: 'Business name' },
            { key: 'visitor_id', name: 'Visitor ID' },
            { key: 'fingerprint_request_id', name: 'Request ID' },
            { key: 'country_code', name: 'Country' },
            { key: 'created', name: 'Created' },
            {
                key: 'same_visitor_signup_count',
                name: 'Signups same visitor',
                sortable: false,
            },
        ],
        [],
    )

    const renderRow = useCallback(
        (id: string) => {
            const item = rows[id] as unknown as FingerprintSignupReportData
            if (!item) {
                return { cols: [] }
            }

            return {
                cols: [
                    renderText(
                        String(item.fingerprint_signup_event_id),
                        'fingerprint_signup_event_id',
                    ),
                    renderProviderId(
                        item.service_provider_id,
                        'service_provider_id',
                        '/service/providers/provider',
                    ),
                    renderText(item.business_name, 'business_name'),
                    renderText(item.visitor_id, 'visitor_id'),
                    renderText(item.fingerprint_request_id ?? '-', 'fingerprint_request_id'),
                    renderText(item.country_code, 'country_code'),
                    renderDate(item.created, 'created'),
                    renderText(String(item.same_visitor_signup_count), 'same_visitor_signup_count'),
                ],
            }
        },
        [rows],
    )

    const handlePageChange = useCallback(
        (page: number) => {
            dispatch(fetchFingerprintSignupReport({ filters, page, country }))
        },
        [dispatch, filters, country],
    )

    return (
        <ReportList
            pages={pages}
            rows={rows as unknown as Record<string, ReportData>}
            isLoading={isLoading}
            pagination={pagination}
            filters={filters}
            fetchData={handlePageChange}
            columns={columns}
            renderRow={renderRow}
            emptyMessage="No fingerprint sign-up events recorded for the current filters."
            loadingMessage="Loading fingerprint sign-up report..."
        />
    )
}

export default FingerprintSignupReportList
